import { createSelector } from "reselect"
import { pick, chain } from "lodash"
import { getAllCategoryItems } from "modules/analyze-performance/selectors/items"
import { getPerformanceHistory } from "modules/analyze-performance/selectors/performance"
import { computePerformanceData } from "helpers/analyze"
import { computeSelected, computeSelectedValue, getLastContributor } from "helpers/contributors"

const getSelectedDate = (state, props) => props.selectedDate
const getSelectedRaw = state => state.modules.analyzePerformanceDetails.selected

const getContributorData = createSelector(
  [getAllCategoryItems, getPerformanceHistory],
  computePerformanceData,
)

export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems],
  computeSelected,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems],
  (data, date, items) => {
    const lastContributor = getLastContributor(data, date) || {}

    return chain(items)
      .map(item => ({
        ...pick(item, "label", "categoryLabel", "id", "color", "favorite", "field", "isAggregated"),
        value: lastContributor[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  computeSelectedValue,
)
